export default (() => {
  let data = {}
  let hasLocalStorage = false

  try {
    const x = 'storageTest'
    localStorage.setItem('x', x)
    localStorage.removeItem('x')
    hasLocalStorage = true
  } catch (e) {
    hasLocalStorage = false
  }

  return {
    setItem: (key, value) => {
      if (hasLocalStorage) {
        localStorage.setItem(key, value)
      } else {
        data[key] = value
      }
    },

    getItem: key => {
      if (hasLocalStorage) {
        return localStorage.getItem(key)
      } else {
        return data[key]
      }
    },

    removeItem: key => {
      if (hasLocalStorage) {
        localStorage.removeItem(key)
      } else {
        delete data[key]
      }
    },

    clear: () => {
      if (hasLocalStorage) {
        localStorage.clear()
      } else {
        data = {}
      }
    },
  }
})()
